module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAFElEQVR4AWP4////u/9QwAClMTkAuTQjzOtg1lEAAAAASUVORK5CYII="